import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class ScreenConfigEditorRoute extends Route
{
	@service ajax

	async model()
	{
		const config = await this.ajax.request("screenConfig.json");
		return config;
	}
}
